import { ICompanyAndFaqsApi, ICourseCard, IWebBanner } from '@/interfaces/homePage';
import { baseApiUrl, domainName } from '@/utils/common/env.constants';
import { randomId } from '@pwskills/rachnaui/utils';
import { domainNameEnums, saasDomains } from '@/utils/Domain';
import { saasDomainprefixUrl, skillsDomainprefixUrl } from '@/utils/Configuration/utils';
import { get, post } from './index';

const prefixUrl = saasDomains.includes(domainName as domainNameEnums)
  ? saasDomainprefixUrl
  : skillsDomainprefixUrl;
class HomePageApi {
  static async getCompanyAndFaqs() {
    return get<ICompanyAndFaqsApi>(`/course/sitemeta?platformType=main&random_id=${randomId()}`);
  }

  static async tagFilter(data: { programType: string; showOnHomePage?: boolean }) {
    return post<ICourseCard>('/course/search?limit=10000&page=1&fullText=true', data);
  }

  static getWebBanner() {
    return get<{ data: IWebBanner[] }>(
      '/banners?type=WEB',
      undefined,
      `${baseApiUrl}/${prefixUrl}`
    );
  }

  static getHomePageData(data?: any) {
    return post('/course/home', data);
  }

  static getHomePageDataV2(data?: any) {
    const baseUrl = '/course/revampedHome';
    const url = data ? `${baseUrl}?freeCourseFilter=${encodeURIComponent(data)}` : baseUrl;
    return get(url);
  }
}

export default HomePageApi;
